var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h5", { staticClass: "mb-2" }, [
        _vm._v("\n    " + _vm._s(_vm.dataComponent.name) + "\n  ")
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "b-row",
        { staticClass: "mt-3" },
        [
          _c(
            "b-col",
            { attrs: { cols: "9" } },
            [
              _c(
                "b-form-group",
                [
                  _c(
                    "b-row",
                    [
                      _c("b-col", { attrs: { cols: "3" } }, [
                        _c("br"),
                        _vm._v(" "),
                        _c("label", [_vm._v("Date")])
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "9" } },
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { cols: "6" } },
                                [
                                  _c("label", [_vm._v("From")]),
                                  _vm._v(" "),
                                  _c("j-datepicker", {
                                    attrs: {
                                      disabled: true,
                                      format: "MMM dd, yyyy",
                                      placeholder: "Ex. Jan 01, 2019"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { cols: "6" } },
                                [
                                  _c("label", [_vm._v("To")]),
                                  _vm._v(" "),
                                  _c("j-datepicker", {
                                    attrs: {
                                      disabled: true,
                                      format: "MMM dd, yyyy",
                                      placeholder: "Ex. Jan 01, 2019"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-group",
                [
                  _c(
                    "b-row",
                    [
                      _c("b-col", { attrs: { cols: "3" } }, [
                        _c("br"),
                        _vm._v(" "),
                        _c("label", [_vm._v("Team")])
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "9" } },
                        [
                          _c(
                            "div",
                            { staticClass: "d-flex justify-content-end" },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "select-label mr-2",
                                  staticStyle: { color: "#4a90e2" }
                                },
                                [
                                  _vm._v(
                                    "\n                Select All\n              "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "label",
                                {
                                  staticClass: "select-label",
                                  staticStyle: { color: "#4a90e2" }
                                },
                                [
                                  _vm._v(
                                    "\n                Unselect All\n              "
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("j-multi-select", {
                            attrs: {
                              disabled: true,
                              placeholder: "Select Team"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-form-group",
                [
                  _c(
                    "b-row",
                    [
                      _c("b-col", { attrs: { cols: "3" } }, [
                        _c("br"),
                        _vm._v(" "),
                        _c("label", [_vm._v("Name")])
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-col",
                        { attrs: { cols: "9" } },
                        [
                          _c(
                            "div",
                            { staticClass: "d-flex justify-content-end" },
                            [
                              _c(
                                "label",
                                {
                                  staticClass: "select-label",
                                  staticStyle: { color: "#4a90e2" }
                                },
                                [
                                  _vm._v(
                                    "\n                Unselect All\n              "
                                  )
                                ]
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("j-multi-select", {
                            attrs: {
                              disabled: true,
                              placeholder: "Select Employee"
                            }
                          }),
                          _vm._v(" "),
                          _c("b-button", { staticClass: "btn blue" }, [
                            _c("i", { staticClass: "fa fa-search mr-2" }),
                            _vm._v("Search\n            ")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("hr"),
      _vm._v(" "),
      _c(
        "b-button",
        { staticClass: "btn grey btn-import-form", attrs: { disabled: "" } },
        [
          _c("i", { staticClass: "fa fa-cloud-download fa-lg" }),
          _vm._v(" Generate xls\n  ")
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "columns mt-3" }, [
        _c(
          "div",
          { staticClass: "d-flex align-items-center" },
          _vm._l(_vm.columns, function(column) {
            return _c(
              "div",
              { key: column, staticClass: "column" },
              [
                _c(
                  "div",
                  {
                    staticClass: "header-list",
                    staticStyle: { cursor: "default !important" }
                  },
                  [
                    _c("div", { staticClass: "column-name" }, [
                      _vm._v(_vm._s(column))
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm._l(4, function(index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "column-preview",
                      class: { "bg-gray": index === 2 || index === 4 },
                      staticStyle: { cursor: "default !important" }
                    },
                    [_c("div", { staticClass: "content-preview" })]
                  )
                })
              ],
              2
            )
          })
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tabs mt-4" }, [
      _c("div", { staticClass: "tab-list tab-active" }, [_vm._v("Overtime")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-231c33d4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-231c33d4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dummy/DummyOvertimeReport.vue
// module id = null
// module chunks = 